import React, { useState, useEffect, useRef, useCallback } from 'react';
import './Controls.css';

var LANGS = [
  {code:'en',name:'English',flag:'🇬🇧'},
  {code:'hi',name:'हिन्दी (Hindi)',flag:'🇮🇳'},
  {code:'ta',name:'தமிழ் (Tamil)',flag:'🇮🇳'},
  {code:'te',name:'తెలుగు (Telugu)',flag:'🇮🇳'},
  {code:'kn',name:'ಕನ್ನಡ (Kannada)',flag:'🇮🇳'},
  {code:'ml',name:'മലയാളം (Malayalam)',flag:'🇮🇳'},
  {code:'mr',name:'मराठी (Marathi)',flag:'🇮🇳'},
  {code:'bn',name:'বাংলা (Bengali)',flag:'🇮🇳'},
  {code:'gu',name:'ગુજરાતી (Gujarati)',flag:'🇮🇳'},
  {code:'pa',name:'ਪੰਜਾਬੀ (Punjabi)',flag:'🇮🇳'},
  {code:'ur',name:'اردو (Urdu)',flag:'🇵🇰'},
  {code:'ar',name:'العربية (Arabic)',flag:'🇸🇦'},
  {code:'zh-CN',name:'中文 (Chinese)',flag:'🇨🇳'},
  {code:'ja',name:'日本語 (Japanese)',flag:'🇯🇵'},
  {code:'ko',name:'한국어 (Korean)',flag:'🇰🇷'},
  {code:'fr',name:'Français (French)',flag:'🇫🇷'},
  {code:'de',name:'Deutsch (German)',flag:'🇩🇪'},
  {code:'es',name:'Español (Spanish)',flag:'🇪🇸'},
  {code:'pt',name:'Português (Portuguese)',flag:'🇧🇷'},
  {code:'it',name:'Italiano (Italian)',flag:'🇮🇹'},
  {code:'ru',name:'Русский (Russian)',flag:'🇷🇺'},
  {code:'th',name:'ไทย (Thai)',flag:'🇹🇭'},
  {code:'vi',name:'Tiếng Việt (Vietnamese)',flag:'🇻🇳'},
  {code:'id',name:'Bahasa Indonesia',flag:'🇮🇩'},
  {code:'ms',name:'Bahasa Melayu (Malay)',flag:'🇲🇾'},
  {code:'tr',name:'Türkçe (Turkish)',flag:'🇹🇷'},
  {code:'nl',name:'Nederlands (Dutch)',flag:'🇳🇱'},
  {code:'pl',name:'Polski (Polish)',flag:'🇵🇱'},
  {code:'fil',name:'Filipino',flag:'🇵🇭'},
  {code:'sw',name:'Kiswahili (Swahili)',flag:'🇰🇪'},
  {code:'ne',name:'नेपाली (Nepali)',flag:'🇳🇵'},
  {code:'si',name:'සිංහල (Sinhala)',flag:'🇱🇰'},
  {code:'my',name:'မြန်မာ (Myanmar)',flag:'🇲🇲'},
  {code:'fa',name:'فارسی (Persian)',flag:'🇮🇷'},
  {code:'uk',name:'Українська (Ukrainian)',flag:'🇺🇦'},
  {code:'sv',name:'Svenska (Swedish)',flag:'🇸🇪'},
  {code:'el',name:'Ελληνικά (Greek)',flag:'🇬🇷'},
  {code:'he',name:'עברית (Hebrew)',flag:'🇮🇱'},
  {code:'ro',name:'Română (Romanian)',flag:'🇷🇴'},
  {code:'hu',name:'Magyar (Hungarian)',flag:'🇭🇺'},
  {code:'af',name:'Afrikaans',flag:'🇿🇦'},
];

function clearAllGoogTransCookies() {
  // Get all possible domain variations
  var host = window.location.hostname; // e.g. bnft.live
  var parts = host.split('.');
  var domains = ['', host, '.' + host];
  // Add root domain: bnft.live and .bnft.live
  if (parts.length >= 2) {
    var root = parts.slice(-2).join('.');
    domains.push(root, '.' + root);
  }
  // Add 3-level: bnft.live and .bnft.live
  if (parts.length >= 3) {
    domains.push(parts.slice(-3).join('.'), '.' + parts.slice(-3).join('.'));
  }
  // Clear on every domain + path combination
  var paths = ['/', ''];
  domains.forEach(function(d) {
    paths.forEach(function(p) {
      var dc = d ? ';domain=' + d : '';
      var pc = p ? ';path=' + p : '';
      document.cookie = 'googtrans=;expires=Thu, 01 Jan 1970 00:00:00 UTC' + pc + dc;
    });
  });
}

function doTranslate(langCode) {
  // Step 1: Clear ALL googtrans cookies on ALL domain levels
  clearAllGoogTransCookies();
  
  // Step 2: Set fresh cookie on all domain levels
  if (langCode !== 'en') {
    var val = '/en/' + langCode;
    var host = window.location.hostname;
    var parts = host.split('.');
    var root = parts.length >= 2 ? parts.slice(-2).join('.') : host;
    document.cookie = 'googtrans=' + val + ';path=/;';
    document.cookie = 'googtrans=' + val + ';path=/;domain=' + host;
    document.cookie = 'googtrans=' + val + ';path=/;domain=.' + host;
    document.cookie = 'googtrans=' + val + ';path=/;domain=' + root;
    document.cookie = 'googtrans=' + val + ';path=/;domain=.' + root;
  }
  
  // Step 3: Use the Google Translate select element
  var sel = document.querySelector('.goog-te-combo');
  if (sel) {
    sel.value = langCode === 'en' ? 'en' : langCode;
    var evt = document.createEvent('HTMLEvents');
    evt.initEvent('change', true, true);
    sel.dispatchEvent(evt);
    return true;
  }
  
  // Fallback: reload with cookies set
  window.location.reload();
  return false;
}

export default function Controls({ current, total, onNext, onPrev, onGoTo }) {
  var [showLang, setShowLang] = useState(false);
  var [activeLang, setActiveLang] = useState('en');
  var [search, setSearch] = useState('');
  var dropRef = useRef(null);

  // Detect current language on mount
  useEffect(function(){
    var m = document.cookie.match(/googtrans=\/en\/([^;]+)/);
    if(m) setActiveLang(m[1]);
  }, []);

  // Close on outside click
  useEffect(function(){
    if(!showLang) return;
    function handler(e){
      if(dropRef.current && !dropRef.current.contains(e.target)) setShowLang(false);
    }
    document.addEventListener('mousedown', handler);
    return function(){ document.removeEventListener('mousedown', handler); };
  }, [showLang]);

  var handleLangSelect = useCallback(function(code){
    setActiveLang(code);
    setShowLang(false);
    setSearch('');
    
    // Try direct select method first
    var success = doTranslate(code);
    
    if (!success) {
      // Google Translate select not available — set cookie and reload
      // Clear old cookies first
      var domains = ['', window.location.hostname, '.' + window.location.hostname];
      domains.forEach(function(d){
        var dc = d ? ';domain=' + d : '';
        document.cookie = 'googtrans=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/' + dc;
      });
      
      if (code !== 'en') {
        var val = '/en/' + code;
        document.cookie = 'googtrans=' + val + ';path=/;';
        document.cookie = 'googtrans=' + val + ';path=/;domain=' + window.location.hostname;
      }
      window.location.reload();
    }
  }, []);

  var filtered = LANGS.filter(function(l){
    if(!search) return true;
    return l.name.toLowerCase().indexOf(search.toLowerCase()) !== -1 || 
           l.code.toLowerCase().indexOf(search.toLowerCase()) !== -1;
  });

  var activeLabel = LANGS.find(function(l){ return l.code === activeLang; });

  return (
    <>
      <div className="ctrl-lang-wrap" ref={dropRef}>
        <button className="ctrl-lang-btn" translate="no" onClick={function(){ setShowLang(!showLang); }} title="Change Language">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10"/>
            <path d="M2 12h20M12 2c2.5 3 4 6.5 4 10s-1.5 7-4 10c-2.5-3-4-6.5-4-10s1.5-7 4-10z"/>
          </svg>
          <span className="ctrl-lang-label">{activeLabel ? activeLabel.flag + ' ' + activeLabel.code.toUpperCase() : 'EN'}</span>
        </button>
        {showLang && (
          <div className="ctrl-lang-dropdown" translate="no">
            <div className="ctrl-lang-header">
              <span>🌐 Select Language</span>
              <button className="ctrl-lang-close" onClick={function(){ setShowLang(false); }}>✕</button>
            </div>
            <input 
              className="ctrl-lang-search"
              type="text"
              placeholder="Search language..."
              value={search}
              onChange={function(e){ setSearch(e.target.value); }}
              autoFocus
            />
            <div className="ctrl-lang-list">
              {filtered.map(function(lang){
                var isActive = activeLang === lang.code;
                return (
                  <button 
                    key={lang.code} 
                    className={'ctrl-lang-item' + (isActive ? ' ctrl-lang-item--active' : '')}
                    onClick={function(){ handleLangSelect(lang.code); }}
                  >
                    <span className="ctrl-lang-flag">{lang.flag}</span>
                    <span className="ctrl-lang-name">{lang.name}</span>
                    {isActive && <span className="ctrl-lang-check">✓</span>}
                  </button>
                );
              })}
            </div>
            <div className="ctrl-lang-hint">Powered by Google Translate — Free</div>
          </div>
        )}
      </div>

      <div className="ctrl-bar">
        <button className="ctrl-btn" onClick={onPrev} disabled={current === 0}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
        <div className="ctrl-indicator">
          <span className="ctrl-current notranslate">{String(current + 1).padStart(2, '0')}</span>
          <span className="ctrl-sep">/</span>
          <span className="ctrl-total notranslate">{String(total).padStart(2, '0')}</span>
        </div>
        <button className="ctrl-btn" onClick={onNext} disabled={current === total - 1}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M9 18l6-6-6-6"/></svg>
        </button>
      </div>

      <div className="ctrl-dots notranslate">
        {Array.from({ length: total }, function(_, i){
          return (
            <button
              key={i}
              className={'ctrl-dot' + (i === current ? ' ctrl-dot--active' : '')}
              onClick={function(){ onGoTo(i); }}
              title={'Slide ' + (i + 1)}
            />
          );
        })}
      </div>

      <div className="ctrl-corner-bl">
        <span className="ctrl-label notranslate">BNFT</span>
      </div>
      <div className="ctrl-corner-br">
        <span className="ctrl-label notranslate">bnft.live</span>
      </div>
    </>
  );
}
